/** InsCoder WANG.J 2026-07-15 B + In-card video switch for portrait video cards **/
(function () {
  function getVideoPlayer(card) {
    return card.querySelector('video-element');
  }

  function getNativeVideo(card) {
    return card.querySelector('.card-image-v3-video .native-video');
  }

  function getExternalVideoFrame(card) {
    return card.querySelector('[data-external-video-frame]');
  }

  function pauseCard(card) {
    if (!card) return;
    var poster = card.querySelector('[data-video-poster]');
    var videoContainer = card.querySelector('[data-video-container]');
    card.classList.remove('is-video-active');
    if (poster) poster.style.display = 'block';
    if (videoContainer) videoContainer.style.display = 'none';

    var videoElement = getVideoPlayer(card);
    if (videoElement && typeof videoElement.pause === 'function') {
      videoElement.pause();
    }

    var nativeVideo = getNativeVideo(card);
    if (nativeVideo && typeof nativeVideo.pause === 'function') {
      nativeVideo.pause();
      try {
        nativeVideo.currentTime = 0;
      } catch (error) {
        // Ignore seek errors from browsers that block currentTime before metadata.
      }
    }

    var externalFrame = getExternalVideoFrame(card);
    if (externalFrame && externalFrame.getAttribute('src') !== 'about:blank') {
      externalFrame.setAttribute('src', 'about:blank');
    }
  }

  function setContentExpanded(card, expanded) {
    if (!card) return;
    var toggle = card.querySelector('[data-card-content-toggle]');
    card.classList.toggle('is-content-expanded', expanded);
    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute('aria-label', expanded ? 'Hide card content' : 'Show all card content');
    }
  }

  function closeOtherExpandedCards(currentCard) {
    document.querySelectorAll('.card-image-v3--expandable.is-content-expanded').forEach(function (card) {
      if (card !== currentCard) setContentExpanded(card, false);
    });
  }

  function playCard(card) {
    if (!card) return;
    var poster = card.querySelector('[data-video-poster]');
    var videoContainer = card.querySelector('[data-video-container]');

    document.querySelectorAll('[data-video-card].is-video-active').forEach(function (activeCard) {
      if (activeCard !== card) {
        pauseCard(activeCard);
      }
    });

    setContentExpanded(card, false);

    card.classList.add('is-video-active');
    if (poster) poster.style.display = 'none';
    if (videoContainer) videoContainer.style.display = 'block';

    var videoElement = getVideoPlayer(card);
    if (videoElement && typeof videoElement.play === 'function') {
      videoElement.play();
    }

    var nativeVideo = getNativeVideo(card);
    if (nativeVideo && typeof nativeVideo.play === 'function') {
      var playPromise = nativeVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    var externalFrame = getExternalVideoFrame(card);
    if (externalFrame && externalFrame.dataset.src) {
      externalFrame.setAttribute('src', externalFrame.dataset.src);
    }
  }

  function bindVideoCard(card) {
    if (!card || card.dataset.videoCardBound === 'true') return;

    card.dataset.videoCardBound = 'true';

    var nativeVideo = getNativeVideo(card);

    if (nativeVideo) {
      nativeVideo.addEventListener('ended', function () {
        pauseCard(card);
      });
    }

    pauseCard(card);
  }

  function bindContentToggle(toggle) {
    if (!toggle || toggle.dataset.cardContentToggleBound === 'true') return;

    toggle.dataset.cardContentToggleBound = 'true';
    toggle.addEventListener('click', function (event) {
      var expandableCard = toggle.closest('.card-image-v3--expandable');
      if (!expandableCard || !window.matchMedia('(min-width: 768px)').matches) return;

      event.preventDefault();
      event.stopPropagation();

      var shouldExpand = !expandableCard.classList.contains('is-content-expanded');
      closeOtherExpandedCards(expandableCard);
      setContentExpanded(expandableCard, shouldExpand);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-video-card]').forEach(bindVideoCard);
    (scope || document).querySelectorAll('[data-card-content-toggle]').forEach(bindContentToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('click', function (event) {
    var expandedCard = event.target.closest('.card-image-v3--expandable.is-content-expanded');
    if (!expandedCard) closeOtherExpandedCards(null);

    var playButton = event.target.closest('[data-video-play]');
    if (playButton) {
      var playCardTarget = playButton.closest('[data-video-card]');
      if (playCardTarget) {
        event.preventDefault();
        event.stopPropagation();
        playCard(playCardTarget);
      }
      return;
    }

    var stopButton = event.target.closest('[data-video-stop]');
    if (stopButton) {
      var stopCardTarget = stopButton.closest('[data-video-card]');
      if (stopCardTarget) {
        event.preventDefault();
        event.stopPropagation();
        pauseCard(stopCardTarget);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var trigger = event.target.closest('[data-video-play], [data-video-stop]');
    if (!trigger) return;

    var targetCard = trigger.closest('[data-video-card]');
    if (!targetCard) return;

    event.preventDefault();
    event.stopPropagation();

    if (trigger.matches('[data-video-play]')) {
      playCard(targetCard);
      return;
    }

    pauseCard(targetCard);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
/** InsCoder WANG.J 2026-07-15 E + In-card video switch for portrait video cards **/
